/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Conexion a API de Financiera en LibroReclamoUnificado
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
(@#)1-A   SOL 32929    Emanuel Guivar           01/08/2025   Cambios fase 2 - Seguros
(@#)2-A   SOL 33756    Emanuel Guivar           05/01/2026   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
--------------------------------------------------------------------------------------------------------------
*/
import Axios from "axios";
import Helpers from "./Helpers";

const ApiUrl: string = `${Helpers.ApiUrl}/api/Financiera`;

const FinancieraAPI = {
    getDocumentosReq: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetDocumentos`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getSolicitudesReq: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetSolicitudes`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getPrestamosReq: (tipoDoc: string, numDoc: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetPrestamos?tipoDoc=${tipoDoc}&numDoc=${numDoc}`;
        const conf = {
            cancelToken: cancelRequest.token, headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
            } };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    //(@#)1-A inicio
    getMediosRespuestaReq: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetMedioRespuesta`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getMedioDevolReq: (prestamo: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetMedioDevolucion?prestamo=${prestamo}`;
        const conf = {
            cancelToken: cancelRequest.token, headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },
    //(@#)1-A fin

    getSegurosReq: (prestamo: string, tipoSol: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetSeguros?prestamo=${prestamo}&tipSol=${tipoSol}`;
        const conf = {
            cancelToken: cancelRequest.token, headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0'
            } };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    //(@#)2-A inicio
    /*
    getCorbeturasReq: (seguro: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetCoberturas?desSeg=${seguro}`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },
    */
    getCorbeturasReq: (seguro: string) => {
        const cancelRequest = Axios.CancelToken.source();

        const conf = {
            params: { desSeg: seguro },
            cancelToken: cancelRequest.token,
        };

        return {
            response: Axios.get<InputSelectData>(`${ApiUrl}/GetCoberturas`, conf),
            cancel: cancelRequest.cancel,
        };
    },
    //(@#)2-A fin

    getDepartamentosSQL: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetDepartamentos`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getProvinciasSQL: (departamento: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetProvincias?departamento=${departamento}`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getDistritosSQL: (departamento: string, provincia: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetDistritos?departamento=${departamento}&provincia=${provincia}`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    postRegistrarReclamoReq: (formData: FormData) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/RegistrarReclamo`;

        const conf = {
            //(@#)2-A inicio
            /*
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            */
            //(@#)2-A fin
            cancelToken: cancelRequest.token
        };

        return {
            response: Axios.post<RespuestaApi>(url, formData, conf),
            cancel: cancelRequest.cancel,
        };
    },

    //(@#)2-A inicio
    GetLocalesReq: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetLocales`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectDataAgen>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    GetDireccionReq: (local: string) => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetDireccion?local=${local}`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getMotivosDesafiliacion: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetMotivosDesafiliacion`;
        const conf = { cancelToken: cancelRequest.token };
        return {
            response: Axios.get<InputSelectData>(url, conf),
            cancel: cancelRequest.cancel,
        };
    },

    getPesoArchivoReq: () => {
        const cancelRequest = Axios.CancelToken.source();
        const url = `${ApiUrl}/GetPesoArchivo`;
        const response = Axios.get<number>(url, { cancelToken: cancelRequest.token })
            .then(res => res.data); // <-- extraer solo el dato

        return {
            response,
            cancel: cancelRequest.cancel,
        };
    },
    //(@#)2-A fin
};

export default FinancieraAPI;